import DashboardReports from "@/components/dashboard/sections/DashboardReports"

const Reports = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="space-y-6">        
        <DashboardReports />
      </div>
    </div>
  )
}

export default Reports
